import { css } from "@emotion/react";
import { useProductDetailsState } from "../../../hooks/useProductDetailsState";
import { useStorefrontSettingsState } from "../../../hooks/useStorefrontSettingsState";
import { useTranslate } from "../../../hooks/useTranslate/useTranslate";
import { AvailabilityCalendarPopupButton } from "../AvailabilityCalendarPopupButton";

//------------------------------------------------------------------------------------
/* Availability */
//export type AvailabilityFieldProps = {};
export const AvailabilityField: React.FC /*<AvailabilityFieldProps>*/ = () => {
	const productDetailsState = useProductDetailsState();
	const product = productDetailsState.get().product;
	const translate = useTranslate();

	const storefrontSettingsState = useStorefrontSettingsState();
	const showOwnedQty =
		storefrontSettingsState.get().settings?.ShowOwnedQty ?? false;
	const totalIn = product?.Availability?.TotalIn ?? 0;
	const total = product?.Availability?.Total ?? 0;
	let available = "";
	if (totalIn > 0) {
		available += totalIn;
		if (showOwnedQty) {
			available += ` ${translate("of")} ${total}`;
		}
		available += ` ${translate("Available")}`;
	} else {
		available = translate("Availability");
	}

	if (product?.Availability) {
		return (
			<div
				className="field availability"
				css={css`
					display: flex;
					flex-direction: column;
					align-items: center;
					gap: 0.5rem;
				`}
			>
				<AvailabilityCalendarPopupButton product={product}>
					<span>{available}</span>
				</AvailabilityCalendarPopupButton>
			</div>
		);
	} else {
		return null;
	}
};
